import { render, staticRenderFns } from "./ModalPatients.template.vue?vue&type=template&id=3448ee42&scoped=true&"
var script = {}
import style0 from "./ModalPatients.template.vue?vue&type=style&index=0&id=3448ee42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3448ee42",
  null
  
)

export default component.exports